import {Side, Turn} from './index.h'
import {SIDE, TURN} from './env'

export function leftSide(side: Side): Side {
  switch (side) {
    case SIDE.UP:
      return SIDE.RIGHT
    case SIDE.DOWN:
      return SIDE.LEFT
    case SIDE.RIGHT:
      return SIDE.DOWN
    case SIDE.LEFT:
      return SIDE.UP
    default:
      throw Error('invalid side')
  }
}

export function rightSide(side: Side): Side {
  switch (side) {
    case SIDE.UP:
      return SIDE.LEFT
    case SIDE.DOWN:
      return SIDE.RIGHT
    case SIDE.RIGHT:
      return SIDE.UP
    case SIDE.LEFT:
      return SIDE.DOWN
    default:
      throw Error('invalid side')
  }
}

export function flipSide(side: Side): Side {
  switch (side) {
    case SIDE.UP:
      return SIDE.DOWN
    case SIDE.DOWN:
      return SIDE.UP
    case SIDE.RIGHT:
      return SIDE.LEFT
    case SIDE.LEFT:
      return SIDE.RIGHT
    default:
      throw Error('invalid side')
  }
}

export function getTurnFromTransition(from: Side, to: Side): Turn {
  switch (to) {
    case flipSide(from):
      return TURN.CENTER
    case leftSide(from):
      return TURN.LEFT
    case rightSide(from):
      return TURN.RIGHT
    default:
      throw Error('backward movement')
  }
}
